<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="800"
  >
    <validation-observer ref="salesItemDialogValidation">
      <v-form>
        <v-card v-if="salesItemForm">
          <v-card-title>
            受注情報の編集
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  rules="required"
                  name="売上品目"
                >
                  <v-select
                    v-model="salesItemForm.sales_item_code"
                    :items="salesItemPrices"
                    :error-messages="errors"
                    dense
                    item-value="code"
                    hide-details="auto"
                    label="売上品目"
                    outlined
                    persistent-placeholder
                    @change="salesItemCodeChangeEvent"
                  >
                  </v-select>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /JWNET取扱品目 -->
            <!-- 受入量／受入量単位 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  :rules="{ required: true, double: true, min_value: 0.001, max_value: 99999.999, quantityWithDecimal: { int_digits: 5, dec_digits: 3 } }"
                  name="受入量"
                >
                  <v-text-field
                    v-model="salesItemForm.amount_of_acceptance"
                    :error-messages="errors"
                    :show-size="1000"
                    dense
                    label="受入量"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    reverse
                    required
                    type="number"
                    @keydown.69.prevent
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  :rules="{ required: true }"
                  name="受入量単位"
                >
                  <v-select
                    v-model="salesItemForm.amount_of_acceptance_unit_id"
                    :items="salesItemUnits"
                    :error-messages="errors"
                    clearable
                    dense
                    hide-details="auto"
                    label="受入量単位"
                    outlined
                    persistent-placeholder
                    @change="acceptanceUnitChangeEvent"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /数量／受入量単位 -->
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="cancelButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              class="primary"
              @click="applyButtonClickEvent"
            >
              反映
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </v-dialog>
</template>

<script>

import _ from 'lodash'
export default {
  name: 'SalesItemDialog',
  components: {},
  mixins: [],
  props: {
    /**
     * モーダル表示設定
     */
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    /**
     * 編集内容
     */
    salesItem: {
      type: Object,
      default: () => null,
    },
    /**
     * 売上品目リスト
     */
    salesItemPrices: {
      type: Array,
      default: () => [],
    },
    /**
     * 受入量単位リスト
     */
    salesItemUnits: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      salesItemForm: {
        id: null,
        key: null,
        sales_item_code: null,
        sales_item_name: null,
        amount_of_acceptance: null,
        amount_of_acceptance_unit_id: null,
        amount_of_acceptance_unit_name: null,
        _destroy: false,
      },
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.salesItemDialogValidation.reset())
      Object.assign(this.$data.salesItemForm, this.$options.data().salesItemForm);
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {},
  methods: {
    /**
     * 売上品目 チェンジイベント
     */
    salesItemCodeChangeEvent () {
      let salesItemPrice = this.salesItemPrices.find( v => v.code === this.salesItemForm.sales_item_code )
      if (salesItemPrice) {
        // console.log('salesItemCodeChangeEvent', salesItemPrice.name)
        this.salesItemForm.sales_item_name = salesItemPrice.name
      }
    },
    /**
     * 受入量単位 チェンジイベント
     */
    acceptanceUnitChangeEvent () {
      let salesItemUnit = this.salesItemUnits.find(v => v.value === this.salesItemForm.amount_of_acceptance_unit_id)
      if (salesItemUnit) {
        // console.log('acceptanceUnitChangeEvent', salesItemUnit.text)
        this.salesItemForm.amount_of_acceptance_unit_name = salesItemUnit.text
      }
    },
    /**
     * キャンセルボタン クリックイベント
     */
    cancelButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 反映ボタン クリックイベント
     */
    applyButtonClickEvent () {
      this.$refs.salesItemDialogValidation.validate().then((result) => {
        if (result) {
          let clonedForm = _.cloneDeep(this.salesItemForm)
          if (!this.salesItem) {
            clonedForm.key = Math.round( Math.random()*1000000 )
          }
          this.$emit('registerCallback', clonedForm)
        }
      })
    },
    /**
     * 初期表示の設定
     */
    setVariable () {
      if (this.salesItem) {
        if (this.salesItem.amount_of_acceptance) {
          this.salesItem.amount_of_acceptance = parseFloat(this.salesItem.amount_of_acceptance)
        }
        Object.assign(this.$data.salesItemForm, this.salesItem)
        this.salesItemCodeChangeEvent()
        this.acceptanceUnitChangeEvent()
      }
    },
  }
}
</script>
